'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactElements = require('@selfdetermine/react-elements');
var reactForms = require('@selfdetermine/react-forms');
var reactHooks = require('@selfdetermine/react-hooks');
var graphql = require('@selfdetermine/graphql');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        charges {\n          revision\n          name\n          code\n        }\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      query Charge($id: ID!) {\n        viewer {\n          charge(id: $id) {\n            id\n            name\n            revision\n            code\n          }\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation($charge: UpdateChargeInput) {\n      updateCharge(charge: $charge) {\n        id\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation($charge: NewChargeInput!) {\n      addCharge(charge: $charge) {\n        id\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var useCreate = function useCreate() {
  var _useMutation = reactHooks.useMutation(graphql.gql(_templateObject())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(charge) {
    return mutate({
      variables: {
        charge: charge
      }
    });
  };

  return [create, meta];
};

var useUpdate = function useUpdate() {
  var _useMutation3 = reactHooks.useMutation(graphql.gql(_templateObject2())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update(charge) {
    return mutate({
      variables: {
        charge: charge
      }
    });
  };

  return [update, meta];
};

var useCharge = function useCharge() {
  var _data$viewer;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id;

  var _useQuery = reactHooks.useQuery(graphql.gql(_templateObject3()), {
    variables: {
      id: id
    }
  }),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.charge, meta];
};
var useCharges = function useCharges() {
  var _data$viewer2;

  var _useQuery2 = reactHooks.useQuery(graphql.gql(_templateObject4())),
      data = _useQuery2.data,
      meta = _objectWithoutProperties(_useQuery2, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.charges) || [], meta];
};
var ChargeForm = function ChargeForm(_ref2) {
  var onDone = _ref2.onDone,
      onError = _ref2.onError,
      onCancel = _ref2.onCancel,
      defaultValues = _ref2.defaultValues;

  var _useCreate = useCreate(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var _useUpdate = useUpdate(),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      updateMeta = _useUpdate2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  var isLoading = createMeta.loading || updateMeta.loading;
  var error = createMeta.error || updateMeta.error;
  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    loading: isLoading,
    error: error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return create(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return update(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "name",
    label: "Name",
    type: "name",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "code",
    label: "Code",
    type: "code",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "revision",
    label: "Revision",
    type: "revision",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, isCreate ? "Create Charge" : "Update Charge")))));
};
ChargeForm.propTypes = {
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func,
  defaultValues: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].number,
    name: PropTypes__default['default'].string
  })
};
var ChargeCard = function ChargeCard(_ref4) {
  var charge = _ref4.charge,
      children = _ref4.children;
  return /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Header, {
    title: [charge.name, charge.code, charge.revision].filter(Boolean).join(" - ")
  }, children));
};
ChargeCard.propTypes = {
  charge: PropTypes__default['default'].shape({
    name: PropTypes__default['default'].string,
    code: PropTypes__default['default'].string,
    revision: PropTypes__default['default'].string
  }).isRequired,
  children: PropTypes__default['default'].node
};

exports.ChargeCard = ChargeCard;
exports.ChargeForm = ChargeForm;
exports.useCharge = useCharge;
exports.useCharges = useCharges;
